import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
const faqs = [{
  q: '¿Cómo recibiré la Biblioteca?',
  a: 'Inmediatamente después de confirmar tu pago recibirás un correo con acceso para descargar todo el contenido. Podrás consultarlo desde tu computadora, tablet o teléfono cuando quieras.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. El sistema fue diseñado tanto para quienes están empezando como para marcas que ya venden y quieren diferenciarse.'
}, {
  q: '¿Sirve para cualquier producto aromático?',
  a: 'Sí: velas, jabones, difusores, sprays, sales de baño, aceites esenciales, cosmética artesanal y cualquier producto donde el aroma forme parte de la experiencia.'
}, {
  q: '¿Es un pago único?',
  a: 'Sí. Pagas una sola vez y el acceso será tuyo para siempre.'
}, {
  q: '¿Puedo acceder desde cualquier país?',
  a: 'Sí. Todo el contenido está en español y está pensado para emprendedoras de cualquier país hispanohablante. El cambio de moneda es automático a tu país.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tienes una garantía de 30 días. Si consideras que no era para ti, solo escríbenos y recibirás el reembolso completo.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-[#efe7da] px-5 py-14" data-id="element-75" data-mp="11xilfgjy9lu5">
      <div className="mx-auto max-w-md" data-id="element-76" data-mp="11vxpbmhzluu6">
        <h2 className="text-center font-serif-display text-3xl font-bold leading-tight text-[#3b3350]" data-id="element-77" data-mp="16np7p9qzou98">
          Preguntas Frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-78" data-mp="s0maz5ahqpmy">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-[#e4dbcc]" data-id="element-79" data-mp="iycywazkqo7g" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left" aria-expanded={isOpen} data-id="element-80" data-mp="mzgfx0tcyqa9">
                  <span className="font-semibold text-[#3b3350]" data-id="element-81" data-mp="2fwtt8vkflgvw">{f.q}</span>
                  <ChevronDownIcon className={`w-5 h-5 shrink-0 text-[#7c6aa8] transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-82" data-mp="2fur4sfyxfvta" />
                </button>
                <AnimatePresence initial={false} data-id="element-83" data-mp="33lwl0w8s4q44">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-84" data-mp="2ynbkswtj26fo">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-[#5a5266]" data-id="element-85" data-mp="1j6t58yrvz4fn">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}